import React from 'react';
import { Button, Tooltip } from 'antd';
import { DeviceType as DeviceTypeResponse } from '@/DTOS/DeviceType/Response/DeviceType';
import { EditOutlined} from '@ant-design/icons';

export const DeviceColumn = (
  handleEdit: (record: DeviceTypeResponse) => void
) => [
  
  {
    title: 'Device Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'System Type Id',
    dataIndex: 'systemTypeId',
    key: 'systemTypeId',
    hidden: true,
  },
  {
    title: 'Imagine',
    dataIndex: 'imageLink',
    key: 'imageLink',
    render: (record: DeviceTypeResponse) =>
      record?.imageLink[0] ? (
        <img
          src={record.imageLink[0]}
          alt='No Image'
          style={{ width: '100px', height: 'auto' }}
        />
      ) : (
        'No image'
      ),
  },
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
    width: 200,
    

  },
  {
    title: 'System Type',
    dataIndex: ['systemType', 'name'],
    key: 'systemTypeName',
    width: 200,
  },
  {
    title: 'Producator',
    dataIndex: 'producer',
    key: 'producer',
    width: 150, 
  },
  {
    title: 'Furnizor',
    dataIndex: 'provider',
    key: 'provider',
    width: 150, 
  },
  {
    title: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 150, 
  },
  {
    title: 'Pret',
    dataIndex: 'price',
    key: 'price',
    width: 150, 
  },
  {
    title: 'Adaos',
    dataIndex: 'addition',
    key: 'addition',
    width: 150, 
  },
  {
    title: 'Manopera SM (Minute)',
    dataIndex: 'laborTimeSM',
    key: 'laborTimeSM',
    width: 200,
  },
  {
    title: 'Pret Manopera SM',
    dataIndex: 'laborPriceSM',
    key: 'laborPriceSM',
    width: 200,
  },
  {
    title: 'Manopera PM (Minute)',
    dataIndex: 'laborTimeSM',
    key: 'laborTimeSM',
    width: 200,
  },
  {
    title: 'Pret Manopera PM',
    dataIndex: 'laborPriceSM',
    key: 'laborPriceSM',
    width: 200,
  },
  {
    title: 'Actiune',
    dataIndex: '',
    key: 'actions',
    render: (record: DeviceTypeResponse) => (
      <Tooltip title='Modifica'>
      <Button onClick={() => handleEdit(record)} icon={<EditOutlined/>}></Button>
      </Tooltip>
    ),
    width: 120,
    fixed: 'right'
  },
];
